import { MenuIconProps } from './menu-icon.props';
import React from 'react';

export const MenuIconMolecule = (props: MenuIconProps) => {
  return (
    <div
      data-cy="menu-icon"
      className={`block mx-5 cursor-pointer bg-none w-9 h-9 ${props.className}`}
      onClick={props.toggleMenu}
    >
      <span className="w-full bg-waldo-blue block mt-2.5 rounded h-0.1" />
      <span className="w-full bg-waldo-blue block mt-2.5 rounded h-0.1" />
      <span className="w-full bg-waldo-blue block mt-2.5 rounded h-0.1" />
    </div>
  );
};
